<template>
    <div class="template-mail--page">
        <base-form
            class="template-mail position--relative"
        >
            <base-card class="template-mail__content" :add-margins="false">
                <template #card__title >
                    <div class="template-mail__header">
                        <base-field
                            class="template-mail__name"
                            :settings="{
                                label: { class: `${generateLabelClass} template-mail__label`, text: $t('global.templateName') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'name',
                                    name: 'name',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.name,
                                    placeholder: $t('global.templateName'),
                                    browserAutocomplete: 'name',
                                    isRequired: false,
                                    isMissing: errors.missing.name,
                                    noListener: true
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                    </div>
                </template>
                <template #card__body >
                    <div class="template-mail__body">
                        <base-field
                            class="template-mail__subject"
                            :settings="{
                                label: { class: 'template-mail__label capitalize', text: $t('global.subject') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'subject',
                                    name: 'subject',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.subject,
                                    placeholder: $t('global.emailSubject'),
                                    browserAutocomplete: 'name',
                                    isRequired: false,
                                    isMissing: errors.missing.subject,
                                    noListener: true
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="template-mail__attachments"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.attachments')  },
                                input: {
                                    component: 'InputFileDefault',
                                    id: 'attachments',
                                    name: 'attachments',
                                    type: 'file',
                                    value: '',
                                    targetClass: 'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    multipleFiles: true
                                },
                                isEdition: false,
                                reset,
                                allowFilling: true
                            }"
                        />
                        <base-files
                            v-if="hasAttachments"
                            :settings="{
                                files: attachments,
                                templateId: parseInt( $route.params.id ),
                                teste: 'testevalue'
                            }"
                            @deleteFile="updateAttachments"
                        />
                        <div class="template-mail__description">
                            <editor
                                v-model="body"
                                id="body"
                                name="body"
                                api-key="z7h7b8lrk8hcmjia37ztugbuyx0f759bjbrkaknir3fu2l46"
                                :init="{
                                    plugins: 'lists link image table help wordcount',
                                    height: 500,
                                    toolbar: 'undo redo | bold italic backcolor | alignleft aligncenter alignright alignjustify | \
                                        bullist outdent indent | table link image | subscript superscript'
                                }"
                            />
                        </div>
                    </div>
                </template>
            </base-card>
        </base-form>
    </div>
</template>

<script>
// packages
import {
    reactive,
    toRefs,
    computed,
    watch
} from '@vue/composition-api';

// store
import { useActions, storePayload } from '@/hooks/use-store';

// hooks
import { singleStructure } from '@/hooks/use-data';

// Componentes
import Editor from '@tinymce/tinymce-vue';

export default {
    components: {
        ...singleStructure.components,
        Editor,
        BaseFiles: () => import( /* webpackChunkName: 'BaseFiles' */ '@/components/bundles/files/BaseFiles' )
    },
    props: {
        ...singleStructure.props
    },
    setup ( props, { root: { $route } }) {
        const { errors, reset, payload } = storePayload();
        const { actions } = useActions();

        const state = reactive({
            name: '',
            body: props?.model?.body || '',
            attachments: props?.model?.attachments || []
        });

        // Atualiza o array de attachments quando é apagado um anexo com sucesso
        const updateAttachments = url => {
            state.attachments = state.attachments.filter( attachment => attachment.url !== url );
        };

        // Aquando o cancelamento da edição por parte do utilizador
        // é necessário gerar a estrutura inicial do script
        watch( () => reset.value,
            newReset => {
                if ( newReset )
                    state.body = props?.model?.body || '';
            });

        // Está sempre a observar o body e ao haver alterações, manda para o payload.
        watch( () => state.body,
            newBody => {
                if ( newBody && newBody !== props?.model?.body )
                    actions( 'registerField', { name: 'body', value: newBody });
            });

        const generateLabelClass = computed( () => ( $route.meta.isAdd ? 'field__label--hide' : 'capitalize' ) );

        // Verifica se o template de e-mail já tem anexos.
        const hasAttachments = computed( () => state?.attachments?.length );

        return {
            ...toRefs( state ),
            payload,
            errors,
            reset,
            updateAttachments,
            generateLabelClass,
            hasAttachments
        };
    }
};
</script>

<style lang="scss">
    .template-mail {
        max-width: 1400px;
        margin: 0 auto;
        &__label {
            font-size: 20px;
        }
        &__body {
            padding: 30px 40px 0;
        }
        &__attachments {
            margin: 30px 0 30px;
        }
        &__description {
            margin: 30px 0 0;
        }
    }
</style>
